import React, { ReactElement } from 'react';
import { AddressFormData, IAddressData } from '../../../types/Address';
import AddressSummary from '../AddressSummary';
import SectionSummary, { SectionSummaryGroupPosition } from '../SectionSummary';

type EditableShipToSummaryProps = {
  toolTipKey: string;
  disallowEdit?: never;
  disableActionButton?: boolean;
  toolTipText?: string;
  onEditClicked?: () => void;
};

type ReadOnlyShipToSummaryProps = {
  disallowEdit: true;
  disableActionButton?: false;
  onEditClicked?: never;
};

export type ShipToSummaryBaseProps = {
  address: AddressFormData | IAddressData | null;
  toolTipKey: string;
  groupPosition?: SectionSummaryGroupPosition;
  toolTipText?: string;
};

export type ShipToSummaryProps = ShipToSummaryBaseProps &
  (EditableShipToSummaryProps | ReadOnlyShipToSummaryProps);

const ShipToSummary: React.FC<ShipToSummaryProps> = ({
  address,
  disallowEdit,
  disableActionButton,
  groupPosition,
  toolTipText,
  toolTipKey,
  onEditClicked,
}: ShipToSummaryProps) => {
  const getAddressContent = (): ReactElement | string => {
    return address?.address1 ? (
      <AddressSummary address={address as AddressFormData} displayAddressType />
    ) : (
      'No saved addresses'
    );
  };
  return disallowEdit ? (
    <SectionSummary
      title="Ship To"
      content={getAddressContent()}
      groupPosition={groupPosition}
      toolTipKey={toolTipKey}
      linkButtonDataTestId="LinkButton-input-ShipTo-Summary"
    />
  ) : (
    <SectionSummary
      title="Ship To"
      content={getAddressContent()}
      displayActionButton
      actionButtonText="Edit"
      onActionButtonClicked={onEditClicked}
      groupPosition={groupPosition}
      disableActionButton={disableActionButton}
      toolTipText={toolTipText}
      toolTipKey={toolTipKey}
      linkButtonDataTestId="LinkButton-input-ShipTo-Summary"
    />
  );
};

export default ShipToSummary;
